import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getForecastHistoryDownloadList = createApi(`getForecastHistoryDownloadListSlice`, "GET");

const getForecastHistoryDownloadListSlice = createSlice({
  name: 'getForecastHistoryDownloadListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getForecastHistoryDownloadList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getForecastHistoryDownloadList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getForecastHistoryDownloadList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getForecastHistoryDownloadListSlice.reducer;
